<script>
    import { onMount } from "svelte"
    import { firebase, firestore, functions } from "../../firebase/firebase.js";
    import BorderLoader from "../../components/BorderLoader.svelte"
    import EmptyText from "../../components/EmptyText.svelte"
    import { user, userProfile } from "../../store/auth.js"
    import { navigateTo } from "svelte-router-spa";
    import { liveCountries } from "../../store/shared.js"

    export let currentRoute;
    export let params;

    var uid = '';
    var name = '';
    var email = '';
    var password = '';
    var role = 'manager';
    var isDisabled = false;
    var pLoader = false;
    var updateLoading = false;
    var isUserAdmin = false;
    var loading = false;
    var currentUser;
    var allLangs = [];
    var selectedLangs = [];
    var errorMessage = '';
    var warningMessage = ''
    var successMessage = '';
    let selectedCountries = {};

    onMount(async () => {
        await init();
    })

    async function init() {
        try {
            if (currentRoute && currentRoute.namedParams) {
                uid = currentRoute.namedParams['uid'];
                checkUserCredentials();
            }
        } catch (error) {

        }
    }

    $: {
        if ($liveCountries && $liveCountries.length > 0) {
            setLiveCountries();
        }
    }

    $: {


        if ($user && $userProfile) {
            checkUserCredentials();

        }
    }

    function setLiveCountries() {
        for (let i = 0; i < $liveCountries.length; i++) {
            const country = $liveCountries[i];
            if (!selectedCountries[country.id]) {
                selectedCountries[country.id] = [];
            }
        }
    }


    async function checkUserCredentials() {
        try {
            if (uid != 'new') {
                if ($user) {
                    if ($user.uid == uid) {
                        isUserAdmin = true;
                    } else if ($userProfile) {
                        isUserAdmin = $userProfile.role == 'admin' ? true : false;
                    }
                }
            } else {
                if ($user && $userProfile) {
                    isUserAdmin = $userProfile.role == 'admin' ? true : false;
                }
            }
            if (isUserAdmin) {
                if (uid && uid != 'new') pLoader = true;
                await fetchSelectedLanguages();
                if (uid && uid != 'new') fetchCurrentUserProfile(uid);
            }
        } catch (error) {

        }
    }

    async function fetchSelectedLanguages() {
        try {
            var res = await firestore.collection('selectedLanguages').get();
            if (res && res.docs && res.docs.length != 0) {
                allLangs = [...res.docs];
            } else {
                allLangs = [];
            }
        } catch (error) {

        }
    }

    async function fetchCurrentUserProfile(uid) {
        try {
            if (uid) {
                currentUser = await firestore.collection('users').doc(uid).get()
                if (currentUser && currentUser.data()) {
                    name = currentUser.data()['name']
                    email = currentUser.data()['email']
                    role = currentUser.data()['role']
                    selectedLangs = currentUser.data()['languages'] ? currentUser.data()['languages'] : []
                    isDisabled = currentUser.data()['isDisabled'];
                    var tempCountries = {}
                    if (currentUser.data()['countries']) {
                        for (const countryId in currentUser.data()['countries']) {
                            if (currentUser.data()['countries'].hasOwnProperty(countryId)) {
                                const countryLangs = currentUser.data()['countries'][countryId];
                                tempCountries[countryId] = countryLangs && countryLangs.length > 0 ? countryLangs : []
                            }
                        }
                    }
                    selectedCountries = { ...tempCountries }
                }
            }
            pLoader = false;
        } catch (error) {

        }
    }

    function validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function validateUser() {
        warningMessage = ''
        if (!name) {
            warningMessage = 'Name is required';
            return false;
        } else if (!email) {
            warningMessage = 'Email is required';
            return false;
        } else if (!validateEmail(email)) {
            warningMessage = 'Invalid email';
            return false;
        } else if (!password && uid == 'new') {
            warningMessage = 'Password is required';
            return false;
        } else if (password.length < 6 && uid == 'new') {
            warningMessage = 'Password is short, at least 6 characters';
            return false;
        } else if (!role) {
            warningMessage = 'Role is required';
            return false;
        } else if ((role == 'manager' && (!selectedCountries || selectedCountries.length <= 0))) {
            warningMessage = 'Language is required';
            return false;
        }
        return true;
    }

    function validateUpdatingUser() {

        if (!currentUser || !uid || uid == 'new') {
            warningMessage = 'Something is wrong';
            return false;
        }
        return validateUser();
    }

    async function createUser() {
        try {
            if (validateUser()) {
                loading = true;
                var userObject = {
                    name: name,
                    email: email,
                    password: password,
                    role: role,
                    isDisabled: isDisabled,
                    countries: selectedCountries,
                }
                var userSignup = firebase.functions().httpsCallable('userSignup');
                userSignup(userObject)
                    .then(async (result) => {
                        if (result && result.data) {
                            uid = result.data
                            await fetchCurrentUserProfile(result.data)
                            successMessage = 'User created'
                            navigateTo("/admin/users/" + result.data);
                        }
                    })
                    .catch(error => {
                        if (error && error.message) {
                            errorMessage = error.message
                        } else {
                            errorMessage = 'Something went wrong'
                        }
                    })
                    .finally(() => {
                        loading = false;
                    });
            }
        } catch (error) {

        }
    }

    async function updateUser() {
        try {
            successMessage = ''
            errorMessage = ''
            warningMessage = ''
            if (validateUpdatingUser()) {
                updateLoading = true;
                var disableOrEnableUser = firebase.functions().httpsCallable('disableOrEnableUser');
                disableOrEnableUser({
                    isDisabled: isDisabled,
                    name: name,
                    uid: uid
                })
                    .then(async (result) => {
                        await firestore.collection('users').doc(uid).set({
                            name: name,
                            role: role,
                            isDisabled: isDisabled,
                            countries: selectedCountries,
                        }, { merge: true })
                            .then(result => {
                                successMessage = 'User Updated'
                            })
                            .catch(error => {
                                if (error && error.message) {
                                    errorMessage = error.message
                                } else {
                                    errorMessage = 'Failed to update user'
                                }
                            })
                    })
                    .catch(error => {
                        if (error && error.message) {
                            errorMessage = error.message
                        } else {
                            errorMessage = 'Failed to update user'
                        }
                    })
                    .finally(() => {
                        updateLoading = false;
                    });
            }
        } catch (error) {
        }
    }

</script>

<div class="wrapper">
    {#if isUserAdmin}
    {#if pLoader}
        <div class="row no-gutters w-100 h-100 d-flex flex-column justify-content-center align-items-center">
            <div class="mb-3">
                <BorderLoader />
            </div>
            <div>
                <EmptyText msg="Fetching user profile..."/>
            </div>
        </div>
    {:else}
        <div class="my_header">
            {#if currentUser}
                <div>
                    User Preview            
                </div>
                {#if updateLoading}
                    <button class="btn btn-outline-primary btn-sm" type="button">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span class="sr-only">Loading...</span>
                    </button>
                {:else}
                    <button on:click="{updateUser}" type="button" class="btn btn-outline-primary btn-sm">UPDATE</button>
                {/if}
            {:else}
                <div>
                    New User   
                </div>
                {#if loading}
                    <button class="btn btn-outline-primary btn-sm" type="button">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span class="sr-only">Loading...</span>
                    </button>
                {:else}
                    <button on:click="{createUser}" type="button" class="btn btn-outline-primary btn-sm">CREATE</button>
                {/if}
            {/if}
        </div>
        <div class="row w-100 justify-content-center align-items-center flex-column">
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 pb-5">
                <div class="row no-gutters">
                    <div class="user_profile_info">
                        <div class="row no-gutters mt-5">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                {#if errorMessage}
                                    <div class="py-4 alert alert-danger alert-dismissible fade show" role="alert">
                                        <strong>Alert!</strong> {errorMessage}
                                    </div>
                                  {/if}
                                  {#if warningMessage}
                                    <div class="py-4 alert alert-warning fade show" role="alert">
                                        <strong>Warning! </strong> {warningMessage}
                                    </div>
                                  {/if}
                                  {#if successMessage}
                                    <div class="py-4 alert alert-success fade show" role="alert">
                                        <strong>Success! </strong> {successMessage}
                                    </div>
                                  {/if}
                                <form>
                                    <div class="form-group">
                                        <input bind:value="{name}" type="text" placeholder="Name" class="form-control" id="nameInpu">
                                    </div>
                                    <div class="form-group">
                                        <input disabled="{currentUser}" bind:value="{email}" type="email" placeholder="Email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
                                    </div>
                                    {#if !currentUser && uid == 'new'}
                                        <div class="form-group">
                                            <input disabled="{currentUser}" minlength="6" required bind:value="{password}" type="password" placeholder="Password" class="form-control" id="passwordInput" aria-describedby="passwordHelp">
                                        </div>
                                    {/if}
                                    <div class="form-group">
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <label class="input-group-text" for="inputGroupSelect01">Role</label>
                                            </div>
                                            <select bind:value="{role}" class="custom-select" id="inputGroupSelect01">
                                                <option value="admin">Admin</option>
                                                <option value="manager" selected>Manager</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input bind:checked={isDisabled} type="checkbox" class="custom-control-input" id="is_disabled">
                                            <label class="custom-control-label" for="is_disabled">Is Disabled</label>
                                        </div>
                                    </div>
                                    {#if role == 'manager'}
                                        <div class="form-group">
                                            <!-- countries and langs -->
                                            <div class="row no-gutters">
                                                <div class="col">
                                                    <div class="form-group">
                                                        <label style="padding-bottom: 10px;" for="countries">Countries & Languages</label>
                                                        <div id="countries">
                                                            {#if $liveCountries && $liveCountries.length != 0}
                                                                <ul class="list-group">
                                                                    {#each $liveCountries as country, i}
                                                                        <i class="list-group-item-secondary" data-toggle="collapse" data-target="{'#collapse_' + i}" aria-expanded="false" aria-controls="{'#collapse_' + i}" style="cursor: pointer; text-align: left !important; font-size: 13px; width: 100% !important;" class:list-group-item="{true}" class:list-group-item-action="{true}">
                                                                            <b>{ country['name'] }</b>
                                                                        </i>
                                                                        <div style="padding: 10px 0 10px 10px;" class="collapse" id="{'collapse_' + i}">
                                                                            {#if selectedCountries[country.id] && selectedCountries[country.id].length >= 0}
                                                                                <select bind:value="{selectedCountries[country.id]}" id="lang_select" class="custom-select" multiple>
                                                                                    {#each country['liveLanguages'] as lang, i}
                                                                                        <option value="{lang['code']}">{ lang['name'] }</option>
                                                                                    {/each}
                                                                                </select>
                                                                            {/if}
                                                                        </div>
                                                                    {/each}
                                                                </ul>
                                                            
                                                            {:else}
                                                                <div style="width: 100%; display: flex; font-size: 13px;">
                                                                    <span class="text-secondary" style="text-align: center; width: 100%;">No countires</span>
                                                                </div>
                                                            {/if}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    {/if}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
{/if}
</div>

<style>
    .user_profile_info{
        width: 100% !important;
    }

    .wrapper{
        border-right: 1px solid #f4f4f4;
        height: 100%;
    }

    .my_header {
        background-color: #efefef;
        display: block;
        width: 100%;
        min-height: 68px;
        border-bottom: 1px solid #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }
</style>